import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { RouteError } from './components/route-shell/RouteError'
import { RoutePending } from './components/route-shell/RoutePending'

/**
 * Navigation data policy (ADR 0027): discrete-fetch routes declare loaders +
 * layout-family pendingComponents; these defaults make the policy felt.
 *
 * - `defaultPendingMs: 0` / `defaultPendingMinMs: 200` — the outgoing page never lingers
 *   (the reported bug was the old page holding through sub-second loads under the library
 *   default of 1000ms); once shown, a pending state holds ≥200ms against flash.
 * - `defaultPreload: 'intent'` + 150ms delay — a deliberate hover starts the destination's
 *   loader before the click; the delay keeps cursor sweeps from firing speculative fetches.
 * - `defaultGcTime: 5min` — preloaded documents (PDFs included) don't accumulate in memory.
 *
 * Timing values are config, not behavior: they are deliberately untested (the e2e net
 * verifies ordering — skeleton before content, hover fires the loader — never durations).
 */
export const router = createRouter({
  routeTree,
  defaultPendingMs: 0,
  defaultPendingMinMs: 200,
  defaultPreload: 'intent',
  defaultPreloadDelay: 150,
  defaultGcTime: 5 * 60_000,
  defaultPendingComponent: RoutePending,
  defaultErrorComponent: RouteError,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
